module.exports = __webpack_public_path__ + "static/img/ag_3.36cd316.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_3.png
// module id = 870
// module chunks = 1